import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=22117dbb&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22117dbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22117dbb')) {
      api.createRecord('22117dbb', component.options)
    } else {
      api.reload('22117dbb', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=22117dbb&scoped=true&", function () {
      api.rerender('22117dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kspV1OJJZAO0/JS/comp/Accordion.vue"
export default component.exports